<template>
  <div class="components">

  <div class="autocomplete autocomplete_active">

    <div class="autocomplete__wrapper">
      <!-- the input field -->
      <input type="text"
            class="autocomplete__input"
            placeholder=""
            autocomplete="off" />
    </div>
    <!-- the list -->
    <ul class="autocomplete__list">
      <li class="autocomplete__list-item active selected">
        <span>Proekspert AS</span>
        <span class="disabled">Sopruse 157</span>
      </li>
      <li class="autocomplete__list-item">
        <span>Item 2</span>
      </li>
      <li class="autocomplete__list-item selected">
        <span>Item 3</span>
      </li>
      <li class="autocomplete__list-item">
        <span>Item 1</span>
      </li>
      <li class="autocomplete__list-item">
        <span>Item 1</span>
      </li>
      <li class="autocomplete__list-item">
        <span>Item 1</span>
      </li>
      <li class="autocomplete__list-item">
        <span>Item 1</span>
      </li>
      <li class="autocomplete__list-item">
        <span>Item 1</span>
      </li>
    </ul>
  </div>

    <br /><br />

    <a href="#" class="btn btn--main">Link Button</a>
    <button type="button" class="btn btn--main">Action Button</button>
    <a href="#" class="btn btn--main">Very Long Button Text</a>
    <a href="#" class="btn btn--disabled">Button</a>
    <a href="#" class="btn btn--secondary">Button</a>
    <a href="#" class="link link--orange">Important or delete <i class="icon icon--check"></i> </a>
    <a href="#" class="link link--blue">Normal action <i class="icon icon--arrow"></i> </a>
    <a href="#" class="link link--grey">Not important <i class="icon icon--cross"></i> </a>

    <h1>Sample form</h1>
    <h2>Contains different elements</h2>
    <h3>Validation is also there</h3>

    <form class="form example-form">
      <fieldset class="form__fieldset">
        <!-- // textbox // -->
        <div class="form__field">
          <label for="login" class="form__label">Login</label>
          <input type="text" class="form__control" name="login" id="login" value="Text" />
        </div>

        <!-- // textbox with validation error // -->
        <div class="form__field form__field_error">
          <label for="password" class="form__label">Password</label>
          <input type="password" class="form__control" name="pwd" id="pwd" value="*****" />
        </div>

        <!-- // datepicker // -->
        <div class="form__field form__field_datepicker">
          <label for="date" class="form__label">Date</label>
          <datepicker class="form__control"
                      :monday-first=true
                      format="dd.MM.yyyy"
                      value="14.01.2017">
          </datepicker>
          <i class="icon-calendar datepicker-button"></i>
        </div>

      </fieldset>
      <fieldset class="form__fieldset">
        <!-- // checkbox // -->
        <div class="form__field form__field_checkbox">
          <input type="checkbox" name="chk" id="chk">
          <label for="chk">Remember me</label>
        </div>

        <!-- // radio // -->
        <div class="form__field form__field_radio">
          <input type="radio" name="radiobtn" id="radiobtn1" value="1">
          <label for="radiobtn1">Option 1</label>
        </div>
        <div class="form__field form__field_radio">
          <input type="radio" name="radiobtn" id="radiobtn2" value="2">
          <label for="radiobtn2">Option 2</label>
        </div>
      </fieldset>
    </form>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Autocomplete from './Autocomplete';

export default {
  name: 'components-overview',
  components: {
    Datepicker,
    Autocomplete,
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.components {
  width: 100%;
}
.example-form {
  padding: 60px 40px;
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ComponentsOverview.vue